/**
 * Utility for retrieving and managing CSP nonces
 */

/**
 * Gets the CSP nonce from meta tag or any element with nonce attribute
 * @returns The CSP nonce string or placeholder
 */
export const getOrCreateNonce = (): string => {
  const nonceDefault = '__CSP_NONCE__';
  // Retrieve nonce from meta tag
  const metaTag = document.querySelector('meta[name="csp-nonce"]');
  if (metaTag && metaTag.getAttribute('content')) {
    return metaTag.getAttribute('content') || nonceDefault;
  }

  // Fallback to retrieving from any element with nonce
  const nonceElement = document.querySelector('[nonce]');
  if (nonceElement && nonceElement.getAttribute('nonce')) {
    return nonceElement.getAttribute('nonce') || nonceDefault;
  }

  return nonceDefault;
};

// Store the nonce as a singleton for reuse
let cachedNonce: string | null = null;

/**
 * Gets the CSP nonce and caches it for reuse
 * @returns The CSP nonce string
 */
export const getNonce = (): string => {
  if (cachedNonce === null) {
    cachedNonce = getOrCreateNonce();
  }
  return cachedNonce;
};
